// Product types
import {
  PRODUCT_ALLOCATED_PENSION_CASH,
  PRODUCT_ALLOCATED_PENSION_FIXED,
  PRODUCT_ANNUITY_FIXED_TERM,
  PRODUCT_ANNUITY_LIQUID_LIFETIME,
  PRODUCT_ANNUITY_LIFETIME,
  PRODUCT_CARE_PLUS,
  PRODUCT_SUPERANNUATION_FUND_CASH,
  PRODUCT_SUPERANNUATION_FUND_FIXED,
  PRODUCT_TERM_ALLOCATED_PENSION_CASH,
  PRODUCT_TERM_ALLOCATED_PENSION_FIXED,
  PRODUCT_UNIT_TRUST,
  ACCOUNT_NAME,
  ACCOUNT_NUMBER,
  ACCOUNT_TYPE,
  ATE,
  BALANCE,
  CAN_YOU_WITHDRAW,
  DATE,
  DATE_CLOSED,
  FIXED_RATE,
  INDEXATION,
  INVESTMENT_AMOUNT,
  INVESTMENT_STATUS,
  INVESTMENT_STATUS_CLOSED,
  JOINT_INVESTORS,
  MATURITY_DATE,
  MATURITY_VALUE,
  NEXT_PAYMENT,
  NEXT_PAYMENT_CLOSED,
  NEXT_PAYMENT_DATE,
  OPENED,
  PAY_FREQUENCY,
  PAYMENT_AMOUNT,
  PAYMENT_DATE,
  PAYMENT_OPTION,
  INVESTMENT_OPTION_START_DATE,
  POLICY_NAME,
  POLICY_NUMBER,
  POLICY_TYPE,
  PURCHASE_PRICE,
  RCV,
  TAX_STATUS,
  TFN_PROVIDED,
  TERM,
  TTR,
  UNIT_PRICE,
  UNIT_PRICE_CLOSED,
  UNITS,
  UNITS_CLOSED,
  WITHDRAWAL_GUARANTEE,
  WITHDRAWAL_PERIOD_ENDS,
  UPFRONT_ASF_WITH_GST,
  REGULAR_ASF_PER_PAYMENT_AMT,
  REGULAR_ASF_TYPE,
  REGULAR_ASF_CONSENT_EXPIRY_DATE
} from './constants';

export const detailMap = {};

// AllocatedPensionCash
detailMap[PRODUCT_ALLOCATED_PENSION_CASH] = {};
detailMap[PRODUCT_ALLOCATED_PENSION_CASH].active = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: BALANCE,
  f5: INVESTMENT_OPTION_START_DATE,
  f6: PAY_FREQUENCY,
  f7: NEXT_PAYMENT,
  f8: PAYMENT_DATE,
  f9: CAN_YOU_WITHDRAW,
  f10: TTR,
};
detailMap[PRODUCT_ALLOCATED_PENSION_CASH].closed = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: BALANCE,
  f5: INVESTMENT_OPTION_START_DATE,
  f6: PAY_FREQUENCY,
  f7: NEXT_PAYMENT_CLOSED,
  f8: DATE_CLOSED,
  f9: CAN_YOU_WITHDRAW,
  f10: TTR,
};

// AllocatedPensionFixed
detailMap[PRODUCT_ALLOCATED_PENSION_FIXED] = {};
detailMap[PRODUCT_ALLOCATED_PENSION_FIXED].active = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: INVESTMENT_AMOUNT,
  f5: INVESTMENT_OPTION_START_DATE,
  f6: PAY_FREQUENCY,
  f7: NEXT_PAYMENT,
  f8: PAYMENT_DATE,
  f9: TERM,
  f10: MATURITY_DATE,
  f11: MATURITY_VALUE,
  f12: FIXED_RATE,
  f13: TTR,
  f14: INDEXATION,
  f15: CAN_YOU_WITHDRAW,
};
detailMap[PRODUCT_ALLOCATED_PENSION_FIXED].closed = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: INVESTMENT_AMOUNT,
  f5: INVESTMENT_OPTION_START_DATE,
  f6: PAY_FREQUENCY,
  f7: NEXT_PAYMENT_CLOSED,
  f8: DATE_CLOSED,
  f9: TERM,
  f10: MATURITY_DATE,
  f11: MATURITY_VALUE,
  f12: FIXED_RATE,
  f13: TTR,
  f14: INDEXATION,
  f15: CAN_YOU_WITHDRAW,
};

// AnnuityFixedTerm
detailMap[PRODUCT_ANNUITY_FIXED_TERM] = {};
detailMap[PRODUCT_ANNUITY_FIXED_TERM].active = {
  f1: POLICY_NAME,
  f2: POLICY_NUMBER,
  f3: POLICY_TYPE,
  f4: PURCHASE_PRICE,
  f5: PAY_FREQUENCY,
  f6: NEXT_PAYMENT,
  f7: PAYMENT_DATE,
  f9: OPENED,
  f10: TERM,
  f11: MATURITY_DATE,
  f12: MATURITY_VALUE,
  f13: INDEXATION,
  f14: CAN_YOU_WITHDRAW,
  f15: ATE,
  f16: RCV,
  f17: UPFRONT_ASF_WITH_GST,
  f18: REGULAR_ASF_PER_PAYMENT_AMT,
  f19: REGULAR_ASF_TYPE,
  f20: REGULAR_ASF_CONSENT_EXPIRY_DATE,
};
detailMap[PRODUCT_ANNUITY_FIXED_TERM].closed = {
  f1: POLICY_NAME,
  f2: POLICY_NUMBER,
  f3: POLICY_TYPE,
  f4: PURCHASE_PRICE,
  f5: PAY_FREQUENCY,
  f6: NEXT_PAYMENT_CLOSED,
  f7: DATE_CLOSED,
  f9: OPENED,
  f10: TERM,
  f11: MATURITY_DATE,
  f12: MATURITY_VALUE,
  f13: INDEXATION,
  f14: CAN_YOU_WITHDRAW,
  f15: ATE,
  f16: RCV,
  f17: UPFRONT_ASF_WITH_GST,
  f18: REGULAR_ASF_PER_PAYMENT_AMT,
  f19: REGULAR_ASF_TYPE,
  f20: REGULAR_ASF_CONSENT_EXPIRY_DATE,
};

// AnnuityLiquidLifetime
detailMap[PRODUCT_ANNUITY_LIQUID_LIFETIME] = {};
detailMap[PRODUCT_ANNUITY_LIQUID_LIFETIME].active = {
  f1: POLICY_NAME,
  f2: POLICY_NUMBER,
  f3: POLICY_TYPE,
  f4: PURCHASE_PRICE,
  f5: PAY_FREQUENCY,
  f6: NEXT_PAYMENT,
  f7: PAYMENT_DATE,
  f9: OPENED,
  f10: TERM,
  f11: PAYMENT_OPTION,
  f13: ATE,
  f14: WITHDRAWAL_GUARANTEE,
  f15: CAN_YOU_WITHDRAW,
  f16: WITHDRAWAL_PERIOD_ENDS,
  f17: UPFRONT_ASF_WITH_GST,
  f18: REGULAR_ASF_PER_PAYMENT_AMT,
  f19: REGULAR_ASF_TYPE,
  f20: REGULAR_ASF_CONSENT_EXPIRY_DATE,
};
detailMap[PRODUCT_ANNUITY_LIQUID_LIFETIME].closed = {
  f1: POLICY_NAME,
  f2: POLICY_NUMBER,
  f3: POLICY_TYPE,
  f4: PURCHASE_PRICE,
  f5: PAY_FREQUENCY,
  f6: NEXT_PAYMENT_CLOSED,
  f7: DATE_CLOSED,
  f9: OPENED,
  f10: TERM,
  f11: PAYMENT_OPTION,
  f13: ATE,
  f14: WITHDRAWAL_GUARANTEE,
  f15: CAN_YOU_WITHDRAW,
  f16: WITHDRAWAL_PERIOD_ENDS,
  f17: UPFRONT_ASF_WITH_GST,
  f18: REGULAR_ASF_PER_PAYMENT_AMT,
  f19: REGULAR_ASF_TYPE,
  f20: REGULAR_ASF_CONSENT_EXPIRY_DATE,
};

// AnnuityLifetime
detailMap[PRODUCT_ANNUITY_LIFETIME] = {};
detailMap[PRODUCT_ANNUITY_LIFETIME].active = {
  f1: POLICY_NAME,
  f2: POLICY_NUMBER,
  f3: POLICY_TYPE,
  f4: PURCHASE_PRICE,
  f5: PAY_FREQUENCY,
  f6: NEXT_PAYMENT,
  f7: PAYMENT_DATE,
  f9: OPENED,
  f10: TERM,
  f11: PAYMENT_OPTION,
  f13: ATE,
  f14: WITHDRAWAL_GUARANTEE,
  f15: CAN_YOU_WITHDRAW,
};
detailMap[PRODUCT_ANNUITY_LIFETIME].closed = {
  f1: POLICY_NAME,
  f2: POLICY_NUMBER,
  f3: POLICY_TYPE,
  f4: PURCHASE_PRICE,
  f5: PAY_FREQUENCY,
  f6: NEXT_PAYMENT_CLOSED,
  f7: DATE_CLOSED,
  f9: OPENED,
  f10: TERM,
  f11: PAYMENT_OPTION,
  f13: ATE,
  f14: WITHDRAWAL_GUARANTEE,
  f15: CAN_YOU_WITHDRAW,
};

// CarePlus
detailMap[PRODUCT_CARE_PLUS] = {};
detailMap[PRODUCT_CARE_PLUS].active = {
  f1: POLICY_NAME,
  f2: POLICY_NUMBER,
  f3: POLICY_TYPE,
  f5: NEXT_PAYMENT,
  f6: PAYMENT_DATE,
  f7: TERM
};
detailMap[PRODUCT_CARE_PLUS].closed = {
  f1: POLICY_NAME,
  f2: POLICY_NUMBER,
  f3: POLICY_TYPE,
  f5: NEXT_PAYMENT_CLOSED,
  f6: DATE_CLOSED,
  f7: TERM
};

// SupperannuationFundCash
detailMap[PRODUCT_SUPERANNUATION_FUND_CASH] = {};
detailMap[PRODUCT_SUPERANNUATION_FUND_CASH].active = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: BALANCE,
  f5: OPENED,
  f6: INVESTMENT_AMOUNT,
  f8: INVESTMENT_STATUS,
};
detailMap[PRODUCT_SUPERANNUATION_FUND_CASH].closed = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: BALANCE,
  f5: OPENED,
  f6: INVESTMENT_AMOUNT,
  f8: INVESTMENT_STATUS_CLOSED,
};

// SupperannuationFundFixed
detailMap[PRODUCT_SUPERANNUATION_FUND_FIXED] = {};
detailMap[PRODUCT_SUPERANNUATION_FUND_FIXED].active = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: INVESTMENT_AMOUNT,
  f5: OPENED,
  f6: INVESTMENT_STATUS,
  f7: FIXED_RATE,
  f9: TERM,
  f10: MATURITY_DATE,
  f11: MATURITY_VALUE,
};
detailMap[PRODUCT_SUPERANNUATION_FUND_FIXED].closed = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: INVESTMENT_AMOUNT,
  f5: OPENED,
  f6: INVESTMENT_STATUS_CLOSED,
  f7: FIXED_RATE,
  f9: TERM,
  f10: MATURITY_DATE,
  f11: MATURITY_VALUE,
};

// TermAllocatedPensionCash
detailMap[PRODUCT_TERM_ALLOCATED_PENSION_CASH] = {};
detailMap[PRODUCT_TERM_ALLOCATED_PENSION_CASH].active = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: BALANCE,
  f5: INVESTMENT_OPTION_START_DATE,
  f6: PAY_FREQUENCY,
  f7: NEXT_PAYMENT,
  f8: PAYMENT_DATE,
  f9: CAN_YOU_WITHDRAW,
  f10: ATE,
};
detailMap[PRODUCT_TERM_ALLOCATED_PENSION_CASH].closed = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: BALANCE,
  f5: INVESTMENT_OPTION_START_DATE,
  f6: PAY_FREQUENCY,
  f7: NEXT_PAYMENT_CLOSED,
  f8: DATE_CLOSED,
  f9: CAN_YOU_WITHDRAW,
  f10: ATE,
};

// TermAllocatedPensionFixed
detailMap[PRODUCT_TERM_ALLOCATED_PENSION_FIXED] = {};
detailMap[PRODUCT_TERM_ALLOCATED_PENSION_FIXED].active = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: INVESTMENT_AMOUNT,
  f5: PAY_FREQUENCY,
  f6: NEXT_PAYMENT,
  f7: PAYMENT_DATE,
  f8: MATURITY_DATE,
  f9: CAN_YOU_WITHDRAW,
  f10: ATE,
  f11: INDEXATION,
  f12: TERM,
  f16: MATURITY_VALUE,
};
detailMap[PRODUCT_TERM_ALLOCATED_PENSION_FIXED].closed = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: INVESTMENT_AMOUNT,
  f5: PAY_FREQUENCY,
  f6: NEXT_PAYMENT_CLOSED,
  f7: DATE_CLOSED,
  f8: MATURITY_DATE,
  f9: CAN_YOU_WITHDRAW,
  f10: ATE,
  f11: INDEXATION,
  f12: TERM,
  f16: MATURITY_VALUE,
};

// UnitTrust
detailMap[PRODUCT_UNIT_TRUST] = {};
detailMap[PRODUCT_UNIT_TRUST].active = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: BALANCE,
  f5: OPENED,
  f6: TAX_STATUS,
  f7: TFN_PROVIDED,
  f8: INVESTMENT_STATUS,
  f9: DATE,
  f10: UNITS,
  f11: UNIT_PRICE,
};
detailMap[PRODUCT_UNIT_TRUST].closed = {
  f1: ACCOUNT_NAME,
  f2: ACCOUNT_NUMBER,
  f3: ACCOUNT_TYPE,
  f4: BALANCE,
  f5: OPENED,
  f6: TAX_STATUS,
  f7: TFN_PROVIDED,
  f8: INVESTMENT_STATUS_CLOSED,
  f9: DATE,
  f10: UNITS_CLOSED,
  f11: UNIT_PRICE_CLOSED,
};
